export default __webpack_public_path__ + "static/media/book-big@2x.ddf44c64.png";